// Sound effects using Web Audio API — no audio files needed!
let audioContext = null;

function getAudioContext() {
  if (!audioContext) {
    try {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return null;
    }
  }
  return audioContext;
}

function playTone({ frequency = 440, duration = 0.1, type = 'sine', volume = 0.3, delay = 0 }) {
  const ctx = getAudioContext();
  if (!ctx) return;

  const oscillator = ctx.createOscillator();
  const gainNode = ctx.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(ctx.destination);

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, ctx.currentTime + delay);
  oscillator.frequency.exponentialRampToValueAtTime(frequency * 0.8, ctx.currentTime + delay + duration);

  gainNode.gain.setValueAtTime(0, ctx.currentTime + delay);
  gainNode.gain.linearRampToValueAtTime(volume, ctx.currentTime + delay + 0.01);
  gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + duration);

  oscillator.start(ctx.currentTime + delay);
  oscillator.stop(ctx.currentTime + delay + duration);
}

// 🃏 Card flip — quick swoosh sound
export function playCardFlip() {
  playTone({ frequency: 800, duration: 0.08, type: 'triangle', volume: 0.2 });
  playTone({ frequency: 600, duration: 0.08, type: 'triangle', volume: 0.15, delay: 0.04 });
}

// 🎴 Card draw — soft thump
export function playCardDraw() {
  playTone({ frequency: 300, duration: 0.12, type: 'triangle', volume: 0.25 });
  playTone({ frequency: 250, duration: 0.1, type: 'sine', volume: 0.15, delay: 0.05 });
}

// 🗑️ Card discard — swoosh down
export function playCardDiscard() {
  const ctx = getAudioContext();
  if (!ctx) return;
  const oscillator = ctx.createOscillator();
  const gainNode = ctx.createGain();
  oscillator.connect(gainNode);
  gainNode.connect(ctx.destination);
  oscillator.type = 'triangle';
  oscillator.frequency.setValueAtTime(500, ctx.currentTime);
  oscillator.frequency.exponentialRampToValueAtTime(200, ctx.currentTime + 0.15);
  gainNode.gain.setValueAtTime(0.2, ctx.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
  oscillator.start(ctx.currentTime);
  oscillator.stop(ctx.currentTime + 0.15);
}

// 🔄 Card swap — two quick clicks
export function playCardSwap() {
  playTone({ frequency: 600, duration: 0.06, type: 'square', volume: 0.15 });
  playTone({ frequency: 700, duration: 0.06, type: 'square', volume: 0.15, delay: 0.08 });
}

// 👁️ Peek — soft chime
export function playPeek() {
  playTone({ frequency: 1200, duration: 0.15, type: 'sine', volume: 0.15 });
}

// 🏆 Round win — ascending arpeggio
export function playRoundWin() {
  [523, 659, 784, 1047].forEach((freq, i) => {
    playTone({ frequency: freq, duration: 0.15, type: 'sine', volume: 0.2, delay: i * 0.1 });
  });
}

// 🎉 Game win — full fanfare
export function playGameWin() {
  [523, 659, 784, 1047, 1319].forEach((freq, i) => {
    playTone({ frequency: freq, duration: 0.2, type: 'sine', volume: 0.25, delay: i * 0.12 });
  });
  playTone({ frequency: 1319, duration: 0.4, type: 'sine', volume: 0.3, delay: 0.7 });
}

// 😔 Round lose — descending tone
export function playRoundLose() {
  [400, 350, 300].forEach((freq, i) => {
    playTone({ frequency: freq, duration: 0.15, type: 'sine', volume: 0.2, delay: i * 0.1 });
  });
}

// Resume audio context on user interaction (required by browsers)
export function resumeAudio() {
  const ctx = getAudioContext();
  if (ctx && ctx.state === 'suspended') {
    ctx.resume();
  }
}
